import { render } from "./xsjjDetail.vue?vue&type=template&id=6ee29f08&scoped=true&ts=true"
import script from "./xsjjDetail.vue?vue&type=script&lang=ts"
export * from "./xsjjDetail.vue?vue&type=script&lang=ts"

import "./xsjjDetail.vue?vue&type=style&index=0&id=6ee29f08&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee29f08"]])

export default __exports__